import { connect } from 'react-redux';
import {deleteTimeslotRequest, startOverwriteTimeslot, toggleDeleteTimeslotModal} from "../../../redux/timeslots/actions";
import DeleteTimeSlot from "./DeleteTimeSlot";

const mapStateToProps = (state) => ({
  selectedTimeslot: state.timeslotsReducer.selectedTimeslot,
  deleteTimeslotModalIsOpen: state.timeslotsReducer.deleteTimeslotModalIsOpen,
  bookedReservations: state.timeslotsReducer.bookedReservations,
});

const mapDispatchToProps = {
  deleteTimeslotRequest,
  toggleDeleteTimeslotModal,
  startOverwriteTimeslot,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTimeSlot);
